import { getDemoProducts } from './demoSession'

const clone = (value) => JSON.parse(JSON.stringify(value))
const nowIso = () => new Date().toISOString()

const addDaysIso = (days) => {
  const date = new Date()
  date.setDate(date.getDate() + days)
  return date.toISOString()
}

const addMinutesIso = (minutes) => {
  const date = new Date()
  date.setMinutes(date.getMinutes() + minutes)
  return date.toISOString()
}

const addHoursIso = (hours) => addMinutesIso(hours * 60)

const toYmd = (value) => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toISOString().slice(0, 10)
}

const parseBody = (options = {}) => {
  if (!options.body) return {}
  try {
    return JSON.parse(options.body)
  } catch {
    return {}
  }
}

const toNumber = (value, fallback = 0) => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : fallback
}

const createError = (status, message, data = {}) => {
  const error = new Error(message || `HTTP ${status}`)
  error.response = {
    status,
    data: {
      message: message || `HTTP ${status}`,
      ...data
    }
  }
  return error
}

const normalizeMethod = (method) => String(method || 'GET').toUpperCase()
const generateCode = (prefix = 'CODE') =>
  `${prefix}-${Math.random().toString(36).slice(2, 6).toUpperCase()}${Math.random().toString(36).slice(2, 6).toUpperCase()}`

const pick = (data, ...keys) => {
  for (const key of keys) {
    if (data[key] !== undefined) return data[key]
  }
  return undefined
}

const createSeed = () => ({
  counters: {
    property: 10,
    contract: 10,
    payment: 10,
    tenant: 10,
    agendaService: 10,
    agendaClient: 10,
    agendaAppointment: 10,
    licenseRequest: 1,
    mcProject: 10,
    mcInput: 10,
    mcRun: 10,
    rtCustomer: 10,
    rtEquipment: 10,
    rtLife: 10,
    rtOrder: 10,
    rtMaintenance: 10,
    rtTelemetry: 10,
    rtInspection: 10,
    rtInvoice: 10
  },
  rentalbiz: {
    profile: {
      id: 'demo-rentalbiz',
      email: 'demo.rentalbiz@appemprendedor.local',
      first_name: 'Usuario',
      last_name: 'Demo RentalBiz',
      role: 'landlord',
      phone: '+57 300 000 0000',
      document_number: '',
      address: 'Bogota, Colombia',
      property_invitation_code: '',
      notification_preferences: '{"email":true,"sms":false}'
    },
    telegram: {
      connected: true,
      channel_id: '-1001234567890',
      is_enabled: true,
      updated_at_utc: nowIso()
    },
    properties: [
      {
        id: 'rb-prop-001',
        name: 'Torre Alameda 302',
        address: 'Calle 93 #15-30',
        city: 'Bogota',
        type: 'apartment',
        status: 'rented',
        monthly_rent: 2400000,
        invitation_code: 'PROP-ALAM302'
      },
      {
        id: 'rb-prop-002',
        name: 'Local Centro 14',
        address: 'Carrera 10 #16-45',
        city: 'Bogota',
        type: 'commercial',
        status: 'available',
        monthly_rent: 3200000,
        invitation_code: 'PROP-CEN014'
      },
      {
        id: 'rb-prop-003',
        name: 'Bodega Norte 7',
        address: 'Autopista Norte Km 19',
        city: 'Bogota',
        type: 'warehouse',
        status: 'maintenance',
        monthly_rent: 5100000,
        invitation_code: 'PROP-NOR007'
      }
    ],
    tenants: [
      {
        id: 'rb-tenant-001',
        email: 'j.lopez@demo.com',
        first_name: 'Juan',
        last_name: 'Lopez',
        role: 'tenant',
        phone: '+57 311 555 0101',
        address: 'Bogota',
        property_invitation_code: 'PROP-ALAM302',
        is_active: true
      },
      {
        id: 'rb-tenant-002',
        email: 'm.garcia@demo.com',
        first_name: 'Maria',
        last_name: 'Garcia',
        role: 'tenant',
        phone: '+57 320 555 0199',
        address: 'Bogota',
        property_invitation_code: 'PROP-CEN014',
        is_active: true
      }
    ],
    contracts: [
      {
        id: 'rb-contract-001',
        contract_number: 'CTR-2026-0001',
        property_id: 'rb-prop-001',
        tenant_id: 'rb-tenant-001',
        landlord_id: 'demo-rentalbiz',
        nombres_apellidos_arrendador: 'Carlos Andres Rodriguez',
        start_date: '2026-01-01',
        end_date: '2026-12-31',
        monthly_rent: 2400000,
        security_deposit: 2400000,
        payment_frequency: 'monthly',
        payment_day: 5,
        terms_conditions: 'Pago dentro de los 5 primeros dias de cada mes.',
        special_conditions: 'Incluye cuota de administracion.',
        property_installations: 'Cocina integral, calentador, closets y zona de lavado.',
        status: 'active'
      },
      {
        id: 'rb-contract-002',
        contract_number: 'CTR-2026-0002',
        property_id: 'rb-prop-002',
        tenant_id: 'rb-tenant-002',
        landlord_id: 'demo-rentalbiz',
        nombres_apellidos_arrendador: 'Carlos Andres Rodriguez',
        start_date: '2026-02-01',
        end_date: '2027-01-31',
        monthly_rent: 3200000,
        security_deposit: 3200000,
        payment_frequency: 'monthly',
        payment_day: 10,
        terms_conditions: 'Se paga por transferencia bancaria.',
        special_conditions: '',
        property_installations: 'Parqueadero cubierto y deposito auxiliar.',
        status: 'pending'
      }
    ],
    payments: [
      {
        id: 'rb-payment-001',
        contract_id: 'rb-contract-001',
        user_id: 'rb-tenant-001',
        type: 'rent',
        amount: 2400000,
        due_date: toYmd(addDaysIso(2)),
        payment_date: null,
        payment_method: null,
        reference_number: 'RNT-2401',
        bank_reference: null,
        notes: 'Canon mensual',
        status: 'pending',
        submitted_at: nowIso()
      },
      {
        id: 'rb-payment-002',
        contract_id: 'rb-contract-001',
        user_id: 'rb-tenant-001',
        type: 'water',
        amount: 180000,
        due_date: toYmd(addDaysIso(-4)),
        payment_date: null,
        payment_method: null,
        reference_number: 'WAT-2401',
        bank_reference: null,
        notes: 'Servicio de agua',
        status: 'overdue',
        submitted_at: nowIso()
      },
      {
        id: 'rb-payment-003',
        contract_id: 'rb-contract-002',
        user_id: 'rb-tenant-002',
        type: 'rent',
        amount: 3200000,
        due_date: toYmd(addDaysIso(-12)),
        payment_date: toYmd(addDaysIso(-10)),
        payment_method: 'bankTransfer',
        reference_number: 'RNT-3201',
        bank_reference: 'TRX-99271',
        notes: 'Pago aplicado',
        status: 'paid',
        submitted_at: nowIso()
      }
    ]
  },
  agendalab: {
    services: [
      { id: 'ag-service-001', name: 'Consulta inicial', duration_minutes: 45, price: 120000, is_active: true },
      { id: 'ag-service-002', name: 'Sesion de seguimiento', duration_minutes: 30, price: 90000, is_active: true },
      { id: 'ag-service-003', name: 'Sesion premium', duration_minutes: 60, price: 180000, is_active: true }
    ],
    clients: [
      { id: 'ag-client-001', full_name: 'Laura Pineda', email: 'laura@demo.com', phone: '+57 301 111 2222', notes: '', invitation_code: 'AG-LAURAP01', last_visit_at: addDaysIso(-6) },
      { id: 'ag-client-002', full_name: 'Camilo Rojas', email: 'camilo@demo.com', phone: '+57 302 333 4444', notes: '', invitation_code: 'AG-CAMILO2', last_visit_at: addDaysIso(-2) },
      { id: 'ag-client-003', full_name: 'Sara Medina', email: 'sara@demo.com', phone: '+57 320 999 1111', notes: '', invitation_code: 'AG-SARAM03', last_visit_at: addDaysIso(-15) }
    ],
    appointments: [
      { id: 'ag-app-001', service_id: 'ag-service-001', client_id: 'ag-client-001', start_at_utc: addMinutesIso(90), end_at_utc: addMinutesIso(135), status: 'scheduled', notes: 'Primera visita' },
      { id: 'ag-app-002', service_id: 'ag-service-002', client_id: 'ag-client-002', start_at_utc: addDaysIso(2), end_at_utc: addDaysIso(2.02), status: 'scheduled', notes: 'Control mensual' },
      { id: 'ag-app-003', service_id: 'ag-service-003', client_id: 'ag-client-003', start_at_utc: addDaysIso(-1), end_at_utc: addDaysIso(-0.97), status: 'completed', notes: 'Sesion completada' }
    ],
    schedule: {
      timezone: 'America/Bogota',
      day_start: '08:00',
      day_end: '18:00',
      slot_minutes: 30,
      work_days: [1, 2, 3, 4, 5]
    },
    public_booking_settings: {
      is_enabled: true,
      public_agenda_url: '/public/agendalab/demo',
      display_name: 'AgendaLab Demo',
      description: 'Agenda publica de demostracion.',
      nequi_key: '318474508',
      nequi_key_type: 'telefono'
    },
    telegram: {
      connected: true,
      chat_id: '573001112233',
      is_enabled: true,
      updated_at_utc: nowIso()
    }
  },
  materialCalculator: {
    projects: [
      {
        id: 'mc-proj-001',
        name: 'Casa Campestre Norte',
        projectType: 'casa',
        description: 'Proyecto base para demo de vivienda unifamiliar.',
        countryCode: 'CO',
        currencyCode: 'COP',
        unitSystem: 'metric',
        timeZone: 'America/Bogota',
        rulesetId: 'mc-rule-001',
        status: 'calculated',
        createdAt: addDaysIso(-28),
        updatedAt: addDaysIso(-2),
        lastCalculatedAt: addDaysIso(-2)
      },
      {
        id: 'mc-proj-002',
        name: 'Torre Urbana Etapa 1',
        projectType: 'torre',
        description: 'Anteproyecto de torre de apartamentos.',
        countryCode: 'CO',
        currencyCode: 'COP',
        unitSystem: 'metric',
        timeZone: 'America/Bogota',
        rulesetId: 'mc-rule-002',
        status: 'draft',
        createdAt: addDaysIso(-9),
        updatedAt: addDaysIso(-1),
        lastCalculatedAt: null
      }
    ],
    inputs: [
      { id: 'mc-input-001', projectId: 'mc-proj-001', sectionKey: 'foundation', inputJson: JSON.stringify({ areaM2: 145, depthM: 0.8, thicknessM: 0.25, fillFactor: 0.1 }), updatedAt: addDaysIso(-7) },
      { id: 'mc-input-002', projectId: 'mc-proj-001', sectionKey: 'structure', inputJson: JSON.stringify({ slabs: [{ lengthM: 14, widthM: 10, thicknessM: 0.12 }], beams: [{ count: 8, widthM: 0.25, depthM: 0.35, lengthM: 4.5 }], columns: [{ count: 12, widthM: 0.25, depthM: 0.25, heightM: 3.1 }] }), updatedAt: addDaysIso(-7) },
      { id: 'mc-input-003', projectId: 'mc-proj-001', sectionKey: 'masonry', inputJson: JSON.stringify({ walls: [{ name: 'Muro exterior', lengthM: 38, heightM: 2.7, openingsAreaM2: 9, formatKey: 'bloque-12' }] }), updatedAt: addDaysIso(-6) },
      { id: 'mc-input-004', projectId: 'mc-proj-001', sectionKey: 'tiles', inputJson: JSON.stringify({ floorAreaM2: 120, wallAreaM2: 62, tileType: 'porcelanato', wasteFactor: 0.12 }), updatedAt: addDaysIso(-5) },
      { id: 'mc-input-005', projectId: 'mc-proj-001', sectionKey: 'paint', inputJson: JSON.stringify({ wallAreaM2: 260, roofAreaM2: 130, coats: 2, coverageM2PerLiter: 10 }), updatedAt: addDaysIso(-5) },
      { id: 'mc-input-006', projectId: 'mc-proj-001', sectionKey: 'finishes', inputJson: JSON.stringify({ items: [{ name: 'Estuco interior', unit: 'kg', baseQty: 1000, consumption: 1.05, waste: 0.07 }] }), updatedAt: addDaysIso(-5) },
      { id: 'mc-input-007', projectId: 'mc-proj-002', sectionKey: 'foundation', inputJson: JSON.stringify({ areaM2: 310, depthM: 1.1, thicknessM: 0.3, fillFactor: 0.15 }), updatedAt: addDaysIso(-2) }
    ],
    runs: [
      {
        id: 'mc-run-001',
        projectId: 'mc-proj-001',
        createdAt: addDaysIso(-4),
        resultsJson: JSON.stringify({
          concreteM3: 88.4,
          steelKg: 6213.55,
          blockUnits: 1518.2,
          mortarM3: 10.95,
          tileM2: 203.84,
          paintLiters: 83.2,
          stuccoKg: 1755,
          wasteReserveM3: 8.84
        })
      },
      {
        id: 'mc-run-002',
        projectId: 'mc-proj-001',
        createdAt: addDaysIso(-2),
        resultsJson: JSON.stringify({
          concreteM3: 92.1,
          steelKg: 6469.37,
          blockUnits: 1610.55,
          mortarM3: 11.34,
          tileM2: 210.18,
          paintLiters: 86.4,
          stuccoKg: 1830,
          wasteReserveM3: 9.21
        })
      }
    ],
    rulesets: [
      {
        id: 'mc-rule-001',
        ruleKey: 'CO-NSR10',
        version: '2026.1',
        isActive: true,
        sourceTitle: 'Lineamientos NSR-10 y catalogo interno Acuarela.',
        parameters: [
          { paramKey: 'concrete_kg_per_m3', paramValue: 2400, unit: 'kg/m3' },
          { paramKey: 'steel_kg_per_m3', paramValue: 72, unit: 'kg/m3' },
          { paramKey: 'tile_units_per_m2', paramValue: 11.5, unit: 'u/m2' },
          { paramKey: 'default_waste_factor', paramValue: 0.1, unit: 'ratio' }
        ]
      },
      {
        id: 'mc-rule-002',
        ruleKey: 'LATAM-GENERAL',
        version: '2026.2',
        isActive: false,
        sourceTitle: 'Biblioteca regional de rendimientos de referencia.',
        parameters: [
          { paramKey: 'concrete_kg_per_m3', paramValue: 2350, unit: 'kg/m3' },
          { paramKey: 'steel_kg_per_m3', paramValue: 68, unit: 'kg/m3' },
          { paramKey: 'tile_units_per_m2', paramValue: 11, unit: 'u/m2' },
          { paramKey: 'default_waste_factor', paramValue: 0.12, unit: 'ratio' }
        ]
      }
    ],
    catalog: [
      { id: 'mc-cat-001', sku: 'CEM-50KG', name: 'Cemento gris 50kg', unit: 'bolsa', unitPrice: 42000 },
      { id: 'mc-cat-002', sku: 'ARE-RIO-M3', name: 'Arena de rio', unit: 'm3', unitPrice: 165000 },
      { id: 'mc-cat-003', sku: 'GRA-34-M3', name: 'Grava 3/4', unit: 'm3', unitPrice: 188000 },
      { id: 'mc-cat-004', sku: 'VAR-12MM', name: 'Varilla corrugada 12mm', unit: 'und', unitPrice: 31500 },
      { id: 'mc-cat-005', sku: 'BLO-12', name: 'Bloque estructural 12', unit: 'und', unitPrice: 2850 },
      { id: 'mc-cat-006', sku: 'PIN-VIN-1G', name: 'Pintura vinilica 1 galon', unit: 'und', unitPrice: 73500 },
      { id: 'mc-cat-007', sku: 'POR-60X60', name: 'Porcelanato 60x60', unit: 'm2', unitPrice: 89000 }
    ]
  },
  rentaltech: {
    customers: [
      {
        id: 'rt-cust-001',
        company_name: 'Constructora Andina SAS',
        contact_name: 'Laura Martinez',
        document_number: '901334221-7',
        email: 'compras@andina-demo.co',
        phone: '+57 310 555 0101',
        country: 'Colombia',
        city: 'Bogota',
        address: 'Calle 98 #15-20',
        tier: 'enterprise',
        is_active: true
      },
      {
        id: 'rt-cust-002',
        company_name: 'Obras Urbanas del Norte',
        contact_name: 'Carlos Rojas',
        document_number: '900882114-3',
        email: 'operaciones@obrasnorte-demo.co',
        phone: '+57 311 555 0202',
        country: 'Colombia',
        city: 'Medellin',
        address: 'Cra 43A #1-50',
        tier: 'preferred',
        is_active: true
      },
      {
        id: 'rt-cust-003',
        company_name: 'Infraestructura del Pacifico',
        contact_name: 'Marcela Velez',
        document_number: '900001221-4',
        email: 'proyectos@pacifico-demo.co',
        phone: '+57 320 555 0333',
        country: 'Colombia',
        city: 'Cali',
        address: 'Av 4N #20-10',
        tier: 'standard',
        is_active: true
      }
    ],
    equipments: [
      {
        id: 'rt-eq-001',
        code: 'EQ-EXC-001',
        name: 'Excavadora CAT 320',
        type: 'excavadora',
        brand: 'CAT',
        model: '320 GC',
        serial_number: 'CAT320GC-7781',
        year: 2022,
        asset_value: 780000000,
        hourly_rate: 195000,
        daily_rate: 1450000,
        weekly_rate: 8700000,
        monthly_rate: 31800000,
        lat: 4.6906,
        lng: -74.0820,
        status: 'rented',
        utilization_time_pct: 79,
        utilization_financial_pct: 83
      },
      {
        id: 'rt-eq-002',
        code: 'EQ-BCK-014',
        name: 'Retroexcavadora JCB 3CX',
        type: 'retroexcavadora',
        brand: 'JCB',
        model: '3CX',
        serial_number: 'JCB3CX-4419',
        year: 2021,
        asset_value: 520000000,
        hourly_rate: 150000,
        daily_rate: 1190000,
        weekly_rate: 6900000,
        monthly_rate: 25100000,
        lat: 6.2442,
        lng: -75.5812,
        status: 'available',
        utilization_time_pct: 61,
        utilization_financial_pct: 64
      },
      {
        id: 'rt-eq-003',
        code: 'EQ-CRN-007',
        name: 'Grua telescopica Grove',
        type: 'grua',
        brand: 'Grove',
        model: 'RT540E',
        serial_number: 'GROVE540-1120',
        year: 2019,
        asset_value: 980000000,
        hourly_rate: 245000,
        daily_rate: 1890000,
        weekly_rate: 11200000,
        monthly_rate: 40200000,
        lat: 3.4516,
        lng: -76.5320,
        status: 'maintenance',
        utilization_time_pct: 48,
        utilization_financial_pct: 52
      }
    ],
    lifeSheets: [
      {
        id: 'rt-life-001',
        equipment_id: 'rt-eq-001',
        acquisition_date_utc: '2022-02-10T00:00:00.000Z',
        acquisition_cost: 742000000,
        current_engine_hours: 4820,
        last_preventive_maintenance_utc: addDaysIso(-18),
        last_corrective_maintenance_utc: addDaysIso(-120),
        insurance_policy: 'POL-CAT-2026-01',
        technical_specs_json: '[{"engine":"C4.4","power_hp":174}]',
        documents_json: '[{"name":"manual.pdf","type":"manual"}]',
        notes: 'Equipo principal para movimiento de tierra en obras urbanas.',
        events: [
          { eventDateUtc: addDaysIso(-120), eventType: 'correctivo', description: 'Cambio de bomba hidraulica', cost: 4200000 },
          { eventDateUtc: addDaysIso(-18), eventType: 'preventivo', description: 'Servicio 500h', cost: 1850000 }
        ]
      },
      {
        id: 'rt-life-002',
        equipment_id: 'rt-eq-002',
        acquisition_date_utc: '2021-08-25T00:00:00.000Z',
        acquisition_cost: 488000000,
        current_engine_hours: 5390,
        last_preventive_maintenance_utc: addDaysIso(-22),
        last_corrective_maintenance_utc: addDaysIso(-200),
        insurance_policy: 'POL-JCB-2026-09',
        technical_specs_json: '[{"engine":"JCB Dieselmax","power_hp":92}]',
        documents_json: '[]',
        notes: 'Alta rotacion en alquiler diario.',
        events: [
          { eventDateUtc: addDaysIso(-200), eventType: 'correctivo', description: 'Cambio de llanta delantera', cost: 950000 },
          { eventDateUtc: addDaysIso(-22), eventType: 'preventivo', description: 'Servicio general', cost: 1260000 }
        ]
      }
    ],
    orders: [
      {
        id: 'rt-order-001',
        quote_number: 'Q-2026-0001',
        contract_number: 'RT-CTR-2026-0001',
        equipment_id: 'rt-eq-001',
        customer_id: 'rt-cust-001',
        customer_name: 'Constructora Andina SAS',
        customer_tier: 'enterprise',
        start_utc: addHoursIso(-10),
        end_utc: addHoursIso(70),
        rate_unit: 'day',
        unit_rate: 1450000,
        vat_rate_pct: 19,
        subtotal: 4350000,
        vat_amount: 826500,
        total_amount: 5176500,
        signed: true,
        signer_name: 'Laura Martinez',
        signed_at_utc: addHoursIso(-12),
        created_at_utc: addDaysIso(-2),
        status: 'active'
      },
      {
        id: 'rt-order-002',
        quote_number: 'Q-2026-0002',
        contract_number: 'RT-CTR-2026-0002',
        equipment_id: 'rt-eq-002',
        customer_id: 'rt-cust-002',
        customer_name: 'Obras Urbanas del Norte',
        customer_tier: 'preferred',
        start_utc: addDaysIso(1),
        end_utc: addDaysIso(6),
        rate_unit: 'day',
        unit_rate: 1190000,
        vat_rate_pct: 19,
        subtotal: 5950000,
        vat_amount: 1130500,
        total_amount: 7080500,
        signed: false,
        signer_name: null,
        signed_at_utc: null,
        created_at_utc: addDaysIso(-1),
        status: 'quoted'
      }
    ],
    maintenanceOrders: [
      {
        id: 'rt-maint-001',
        equipment_id: 'rt-eq-003',
        type: 'correctivo',
        trigger_source: 'alerta_vibracion',
        estimated_cost: 5200000,
        status: 'open',
        created_at_utc: addDaysIso(-1)
      },
      {
        id: 'rt-maint-002',
        equipment_id: 'rt-eq-001',
        type: 'preventivo',
        trigger_source: 'horas_motor',
        estimated_cost: 1800000,
        status: 'closed',
        created_at_utc: addDaysIso(-12)
      }
    ],
    telemetry: [
      {
        id: 'rt-tel-001',
        equipment_id: 'rt-eq-001',
        engine_hours: 4820,
        lat: 4.6932,
        lng: -74.0743,
        temperature_c: 92,
        vibration_mm_s: 6.2,
        geofence_alert: false,
        created_at_utc: addMinutesIso(-20)
      },
      {
        id: 'rt-tel-002',
        equipment_id: 'rt-eq-002',
        engine_hours: 5390,
        lat: 6.2501,
        lng: -75.5700,
        temperature_c: 88,
        vibration_mm_s: 5.8,
        geofence_alert: false,
        created_at_utc: addMinutesIso(-55)
      },
      {
        id: 'rt-tel-003',
        equipment_id: 'rt-eq-003',
        engine_hours: 6110,
        lat: 3.4300,
        lng: -76.5400,
        temperature_c: 104,
        vibration_mm_s: 9.1,
        geofence_alert: true,
        created_at_utc: addMinutesIso(-35)
      }
    ],
    inspections: [
      {
        id: 'rt-ins-001',
        equipment_id: 'rt-eq-001',
        rental_order_id: 'rt-order-001',
        type: 'salida',
        checklist_json: JSON.stringify([
          { item: 'Frenos', ok: true },
          { item: 'Luces', ok: true },
          { item: 'Nivel de aceite', ok: true },
          { item: 'Sistema hidraulico', ok: true },
          { item: 'Cabina / controles', ok: true }
        ]),
        photos_json: JSON.stringify([]),
        signature_name: 'Supervisor Campo',
        pdf_report_url: null,
        created_at_utc: addHoursIso(-8)
      }
    ],
    invoices: []
  },
  licenseRequests: []
})

let demoState = null

const getState = () => {
  if (!demoState) {
    demoState = createSeed()
  }
  return demoState
}

const nextId = (type) => {
  const state = getState()
  const nextValue = (state.counters[type] || 1) + 1
  state.counters[type] = nextValue
  return `${type}-${String(nextValue).padStart(4, '0')}`
}

const mapTenant = (tenant) => {
  const state = getState()
  const tenantId = tenant?.id
  const hasContracts = state.rentalbiz.contracts.some((item) => item.tenant_id === tenantId)
  const hasPayments = state.rentalbiz.payments.some((item) => item.user_id === tenantId)

  return {
    ...tenant,
    can_delete: !hasContracts && !hasPayments
  }
}

const mapContract = (contract) => {
  const state = getState()
  const property = state.rentalbiz.properties.find((item) => item.id === contract.property_id) || null
  const tenant = state.rentalbiz.tenants.find((item) => item.id === contract.tenant_id) || null
  const landlord = state.rentalbiz.profile
  return { ...contract, property, tenant, landlord }
}

const mapPayment = (payment) => {
  const contract = mapContract(getState().rentalbiz.contracts.find((item) => item.id === payment.contract_id) || {})
  const user = getState().rentalbiz.tenants.find((item) => item.id === payment.user_id) || null
  return { ...payment, contract, user }
}

const mapAgendaClient = (client) => {
  if (!client) return null

  const state = getState()
  const fullName = String(
    client.fullName ||
    client.full_name ||
    `${client.first_name || ''} ${client.last_name || ''}`.trim() ||
    'Cliente sin nombre'
  ).trim()

  const invitationCode = client.invitationCode || client.invitation_code || null
  const dependencyCount = state.agendalab.appointments.filter((item) => item.client_id === client.id).length

  return {
    ...client,
    fullName,
    full_name: client.full_name || fullName,
    invitationCode,
    invitation_code: client.invitation_code || invitationCode,
    invitationExpiresAtUtc: client.invitationExpiresAtUtc || client.invitation_expires_at_utc || null,
    invitation_expires_at_utc: client.invitation_expires_at_utc || client.invitationExpiresAtUtc || null,
    invitationIsOneTime: client.invitationIsOneTime ?? client.invitation_is_one_time ?? false,
    invitation_is_one_time: client.invitation_is_one_time ?? client.invitationIsOneTime ?? false,
    invitationIsActive: client.invitationIsActive ?? client.invitation_is_active ?? true,
    invitation_is_active: client.invitation_is_active ?? client.invitationIsActive ?? true,
    dependencyCount,
    dependency_count: dependencyCount,
    canDelete: dependencyCount === 0,
    can_delete: dependencyCount === 0,
    canRegenerateInvitation: dependencyCount === 0,
    can_regenerate_invitation: dependencyCount === 0
  }
}

const getStatusByDueDate = (payment) => {
  if (!payment?.due_date) return payment.status || 'pending'
  if (payment.status && payment.status !== 'pending') return payment.status
  const due = new Date(`${payment.due_date}T12:00:00`)
  return due < new Date() ? 'overdue' : 'pending'
}

const computeRentalBizStats = () => {
  const state = getState()
  const properties = state.rentalbiz.properties
  return {
    total: properties.length,
    rented: properties.filter((item) => item.status === 'rented').length,
    available: properties.filter((item) => item.status === 'available').length,
    maintenance: properties.filter((item) => item.status === 'maintenance').length,
    total_monthly_rent: properties.filter((item) => item.status === 'rented').reduce((acc, item) => acc + toNumber(item.monthly_rent), 0),
    totalTrend: 8,
    rentedTrend: 5,
    availableTrend: -3,
    incomeTrend: 11
  }
}

const handleRentalBiz = (path, method, searchParams, body) => {
  const state = getState()

  if (path === '/api/rentalbiz/properties/stats' && method === 'GET') {
    return computeRentalBizStats()
  }

  if (path === '/api/rentalbiz/properties' && method === 'GET') {
    const search = String(searchParams.get('search') || '').toLowerCase()
    const type = String(searchParams.get('type') || '').toLowerCase()
    const status = String(searchParams.get('status') || '').toLowerCase()
    const city = String(searchParams.get('city') || '').toLowerCase()

    return state.rentalbiz.properties.filter((property) => {
      if (search && !`${property.name} ${property.address}`.toLowerCase().includes(search)) return false
      if (type && String(property.type || '').toLowerCase() !== type) return false
      if (status && String(property.status || '').toLowerCase() !== status) return false
      if (city && !String(property.city || '').toLowerCase().includes(city)) return false
      return true
    })
  }

  if (path === '/api/rentalbiz/properties' && method === 'POST') {
    const property = {
      id: nextId('property'),
      name: pick(body, 'name', 'property_name') || 'Nueva propiedad demo',
      address: pick(body, 'address') || '',
      city: pick(body, 'city') || 'Bogota',
      type: pick(body, 'type') || 'apartment',
      status: pick(body, 'status') || 'available',
      monthly_rent: toNumber(pick(body, 'monthly_rent', 'monthlyRent'), 0),
      invitation_code: pick(body, 'invitation_code', 'invitationCode') || null
    }
    state.rentalbiz.properties.unshift(property)
    return property
  }

  if (path === '/api/rentalbiz/contracts' && method === 'GET') {
    return state.rentalbiz.contracts.map(mapContract)
  }

  if (path === '/api/rentalbiz/telegram/status' && method === 'GET') {
    return {
      connected: Boolean(state.rentalbiz.telegram.connected),
      channelId: state.rentalbiz.telegram.channel_id || '',
      chatId: state.rentalbiz.telegram.channel_id || '',
      isEnabled: state.rentalbiz.telegram.is_enabled ?? false,
      updatedAtUtc: state.rentalbiz.telegram.updated_at_utc || nowIso()
    }
  }

  if (path === '/api/rentalbiz/telegram/connect' && method === 'POST') {
    state.rentalbiz.telegram = {
      connected: Boolean(pick(body, 'channelId', 'chatId')),
      channel_id: pick(body, 'channelId', 'chatId') || '',
      is_enabled: pick(body, 'isEnabled') ?? true,
      updated_at_utc: nowIso()
    }
    return {
      connected: state.rentalbiz.telegram.connected,
      channelId: state.rentalbiz.telegram.channel_id,
      chatId: state.rentalbiz.telegram.channel_id,
      isEnabled: state.rentalbiz.telegram.is_enabled,
      updatedAtUtc: state.rentalbiz.telegram.updated_at_utc
    }
  }

  if (path === '/api/rentalbiz/telegram/test' && method === 'POST') {
    return { success: true }
  }

  if (path === '/api/rentalbiz/contracts' && method === 'POST') {
    const propertyId = pick(body, 'property_id', 'propertyId')
    const tenantId = pick(body, 'tenant_id', 'tenantId')
    const contract = {
      id: nextId('contract'),
      contract_number: generateCode('CTR'),
      property_id: propertyId || '',
      tenant_id: tenantId || '',
      landlord_id: state.rentalbiz.profile.id,
      nombres_apellidos_arrendador: pick(body, 'nombres_apellidos_arrendador', 'nombresApellidosArrendador') || `${state.rentalbiz.profile.first_name || ''} ${state.rentalbiz.profile.last_name || ''}`.trim(),
      start_date: pick(body, 'start_date', 'startDate') || toYmd(nowIso()),
      end_date: pick(body, 'end_date', 'endDate') || toYmd(addDaysIso(365)),
      monthly_rent: toNumber(pick(body, 'monthly_rent', 'monthlyRent'), 0),
      security_deposit: toNumber(pick(body, 'security_deposit', 'securityDeposit'), 0),
      payment_frequency: pick(body, 'payment_frequency', 'paymentFrequency') || 'monthly',
      payment_day: toNumber(pick(body, 'payment_day', 'paymentDay'), 5),
      terms_conditions: pick(body, 'terms_conditions', 'termsConditions') || '',
      special_conditions: pick(body, 'special_conditions', 'specialConditions') || '',
      property_installations: pick(body, 'property_installations', 'propertyInstallations', 'instalaciones_inmueble', 'instalacionesInmueble') || '',
      tenant_document_number: pick(body, 'tenant_document_number', 'tenantDocumentNumber') || '',
      debtor_document_number: pick(body, 'debtor_document_number', 'debtorDocumentNumber') || '',
      debtor2_document_number: pick(body, 'debtor2_document_number', 'debtor2DocumentNumber') || '',
      status: pick(body, 'status') || 'active'
    }
    state.rentalbiz.contracts.unshift(contract)
    return mapContract(contract)
  }

  if (path === '/api/rentalbiz/payments' && method === 'GET') {
    return state.rentalbiz.payments
      .map((payment) => ({ ...payment, status: getStatusByDueDate(payment) }))
      .map(mapPayment)
  }

  if (path === '/api/rentalbiz/payments' && method === 'POST') {
    const payment = {
      id: nextId('payment'),
      contract_id: pick(body, 'contractId', 'contract_id') || '',
      user_id: pick(body, 'userId', 'user_id') || '',
      type: pick(body, 'type') || 'rent',
      amount: toNumber(pick(body, 'amount'), 0),
      due_date: pick(body, 'dueDate', 'due_date') || toYmd(addDaysIso(30)),
      payment_date: pick(body, 'paymentDate', 'payment_date') || null,
      payment_method: pick(body, 'paymentMethod', 'payment_method') || null,
      reference_number: pick(body, 'referenceNumber', 'reference_number') || generateCode('PAY'),
      bank_reference: pick(body, 'bankReference', 'bank_reference') || null,
      notes: pick(body, 'notes') || '',
      status: pick(body, 'status') || 'pending',
      submitted_at: nowIso()
    }
    state.rentalbiz.payments.unshift(payment)
    return mapPayment(payment)
  }

  if (path === '/api/rentalbiz/payments/pending' && method === 'GET') {
    return state.rentalbiz.payments
      .map((payment) => ({ ...payment, status: getStatusByDueDate(payment) }))
      .filter((payment) => ['pending', 'overdue'].includes(payment.status))
      .map(mapPayment)
  }

  if (path === '/api/rentalbiz/tenants' && method === 'GET') {
    return state.rentalbiz.tenants.filter((tenant) => tenant.is_active !== false).map(mapTenant)
  }

  if (path === '/api/rentalbiz/tenants' && method === 'POST') {
    const tenant = {
      id: nextId('tenant'),
      email: pick(body, 'email') || '',
      first_name: pick(body, 'first_name', 'firstName') || 'Nuevo',
      last_name: pick(body, 'last_name', 'lastName') || 'Arrendatario',
      role: 'tenant',
      phone: pick(body, 'phone') || '',
      address: pick(body, 'address') || '',
      property_invitation_code: pick(body, 'property_invitation_code', 'propertyInvitationCode') || '',
      is_active: true
    }
    state.rentalbiz.tenants.unshift(tenant)
    return tenant
  }

  const propertyByIdMatch = path.match(/^\/api\/rentalbiz\/properties\/([^/]+)$/)
  if (propertyByIdMatch && method === 'GET') {
    const property = state.rentalbiz.properties.find((item) => item.id === propertyByIdMatch[1])
    if (!property) throw createError(404, 'Propiedad no encontrada.')
    return property
  }
  if (propertyByIdMatch && method === 'PUT') {
    const property = state.rentalbiz.properties.find((item) => item.id === propertyByIdMatch[1])
    if (!property) throw createError(404, 'Propiedad no encontrada.')
    Object.assign(property, {
      ...property,
      ...body,
      monthly_rent: toNumber(pick(body, 'monthly_rent', 'monthlyRent', 'amount'), property.monthly_rent)
    })
    return property
  }
  if (propertyByIdMatch && method === 'DELETE') {
    state.rentalbiz.properties = state.rentalbiz.properties.filter((item) => item.id !== propertyByIdMatch[1])
    return { success: true }
  }

  const propertyCodeMatch = path.match(/^\/api\/rentalbiz\/properties\/([^/]+)\/generate-code$/)
  if (propertyCodeMatch && method === 'POST') {
    const property = state.rentalbiz.properties.find((item) => item.id === propertyCodeMatch[1])
    if (!property) throw createError(404, 'Propiedad no encontrada.')
    property.invitation_code = generateCode('PROP')
    return { invitationCode: property.invitation_code, invitation_code: property.invitation_code }
  }

  if (path === '/api/rentalbiz/properties/validate-invitation-code' && method === 'GET') {
    const code = String(searchParams.get('code') || '').trim().toUpperCase()
    const property = state.rentalbiz.properties.find(
      (item) => String(item.invitation_code || '').trim().toUpperCase() === code
    )
    if (!property) throw createError(404, 'Codigo de invitacion no valido.')
    return property
  }

  const contractByIdMatch = path.match(/^\/api\/rentalbiz\/contracts\/([^/]+)$/)
  if (contractByIdMatch && method === 'GET') {
    const contract = state.rentalbiz.contracts.find((item) => item.id === contractByIdMatch[1])
    if (!contract) throw createError(404, 'Contrato no encontrado.')
    const mapped = mapContract(contract)
    mapped.payments = state.rentalbiz.payments
      .filter((payment) => payment.contract_id === contract.id)
      .map(mapPayment)
    return mapped
  }
  if (contractByIdMatch && method === 'PUT') {
    const contract = state.rentalbiz.contracts.find((item) => item.id === contractByIdMatch[1])
    if (!contract) throw createError(404, 'Contrato no encontrado.')
    Object.assign(contract, {
      ...contract,
      ...body,
      property_id: pick(body, 'property_id', 'propertyId') || contract.property_id,
      tenant_id: pick(body, 'tenant_id', 'tenantId') || contract.tenant_id,
      nombres_apellidos_arrendador: pick(body, 'nombres_apellidos_arrendador', 'nombresApellidosArrendador') || contract.nombres_apellidos_arrendador,
      property_installations: pick(body, 'property_installations', 'propertyInstallations', 'instalaciones_inmueble', 'instalacionesInmueble') || contract.property_installations,
      tenant_document_number: pick(body, 'tenant_document_number', 'tenantDocumentNumber') || contract.tenant_document_number,
      debtor_document_number: pick(body, 'debtor_document_number', 'debtorDocumentNumber') || contract.debtor_document_number,
      debtor2_document_number: pick(body, 'debtor2_document_number', 'debtor2DocumentNumber') || contract.debtor2_document_number,
      monthly_rent: toNumber(pick(body, 'monthly_rent', 'monthlyRent'), contract.monthly_rent)
    })
    return mapContract(contract)
  }
  if (contractByIdMatch && method === 'DELETE') {
    state.rentalbiz.contracts = state.rentalbiz.contracts.filter((item) => item.id !== contractByIdMatch[1])
    state.rentalbiz.payments = state.rentalbiz.payments.filter((item) => item.contract_id !== contractByIdMatch[1])
    return { success: true }
  }

  const terminateContractMatch = path.match(/^\/api\/rentalbiz\/contracts\/([^/]+)\/terminate$/)
  if (terminateContractMatch && method === 'POST') {
    const contract = state.rentalbiz.contracts.find((item) => item.id === terminateContractMatch[1])
    if (!contract) throw createError(404, 'Contrato no encontrado.')
    contract.status = 'terminated'
    return mapContract(contract)
  }

  const paymentByIdMatch = path.match(/^\/api\/rentalbiz\/payments\/([^/]+)$/)
  if (paymentByIdMatch && method === 'GET') {
    const payment = state.rentalbiz.payments.find((item) => item.id === paymentByIdMatch[1])
    if (!payment) throw createError(404, 'Pago no encontrado.')
    payment.status = getStatusByDueDate(payment)
    return mapPayment(payment)
  }
  if (paymentByIdMatch && method === 'PUT') {
    const payment = state.rentalbiz.payments.find((item) => item.id === paymentByIdMatch[1])
    if (!payment) throw createError(404, 'Pago no encontrado.')
    Object.assign(payment, {
      ...payment,
      ...body,
      contract_id: pick(body, 'contractId', 'contract_id') || payment.contract_id,
      amount: toNumber(pick(body, 'amount'), payment.amount),
      due_date: pick(body, 'dueDate', 'due_date') || payment.due_date,
      payment_method: pick(body, 'paymentMethod', 'payment_method') ?? payment.payment_method,
      reference_number: pick(body, 'referenceNumber', 'reference_number') ?? payment.reference_number,
      bank_reference: pick(body, 'bankReference', 'bank_reference') ?? payment.bank_reference,
      payment_date: pick(body, 'paymentDate', 'payment_date') ?? payment.payment_date,
      status: pick(body, 'status') || payment.status
    })
    return mapPayment(payment)
  }
  if (paymentByIdMatch && method === 'DELETE') {
    state.rentalbiz.payments = state.rentalbiz.payments.filter((item) => item.id !== paymentByIdMatch[1])
    return { success: true }
  }

  const paymentMarkPaidMatch = path.match(/^\/api\/rentalbiz\/payments\/([^/]+)\/mark-paid$/)
  if (paymentMarkPaidMatch && method === 'POST') {
    const payment = state.rentalbiz.payments.find((item) => item.id === paymentMarkPaidMatch[1])
    if (!payment) throw createError(404, 'Pago no encontrado.')
    payment.status = 'paid'
    payment.payment_date = pick(body, 'paymentDate', 'payment_date') || toYmd(nowIso())
    payment.payment_method = pick(body, 'paymentMethod', 'payment_method') || payment.payment_method || 'bankTransfer'
    payment.reference_number = pick(body, 'receiptNumber', 'reference_number') || payment.reference_number
    return mapPayment(payment)
  }

  const paymentContractMatch = path.match(/^\/api\/rentalbiz\/payments\/contract\/([^/]+)$/)
  if (paymentContractMatch && method === 'GET') {
    return state.rentalbiz.payments
      .filter((payment) => payment.contract_id === paymentContractMatch[1])
      .map((payment) => ({ ...payment, status: getStatusByDueDate(payment) }))
      .map(mapPayment)
  }

  const tenantByPropertyMatch = path.match(/^\/api\/rentalbiz\/tenants\/by-property\/([^/]+)$/)
  if (tenantByPropertyMatch && method === 'GET') {
    const property = state.rentalbiz.properties.find((item) => item.id === tenantByPropertyMatch[1])
    if (!property) return []
    const code = String(property.invitation_code || '').toUpperCase()
    return state.rentalbiz.tenants
      .filter((tenant) =>
        tenant.is_active !== false &&
        String(tenant.property_invitation_code || '').toUpperCase() === code)
      .map(mapTenant)
  }

  const tenantByIdMatch = path.match(/^\/api\/rentalbiz\/tenants\/([^/]+)$/)
  if (tenantByIdMatch && method === 'PUT') {
    const tenant = state.rentalbiz.tenants.find((item) => item.id === tenantByIdMatch[1])
    if (!tenant) throw createError(404, 'Arrendatario no encontrado.')
    Object.assign(tenant, {
      ...tenant,
      ...body,
      first_name: pick(body, 'first_name', 'firstName') || tenant.first_name,
      last_name: pick(body, 'last_name', 'lastName') || tenant.last_name,
      property_invitation_code: pick(body, 'property_invitation_code', 'propertyInvitationCode') ?? tenant.property_invitation_code
    })
    return tenant
  }
  if (tenantByIdMatch && method === 'DELETE') {
    const tenantId = tenantByIdMatch[1]
    const tenantIndex = state.rentalbiz.tenants.findIndex((item) => item.id === tenantId)
    if (tenantIndex === -1) throw createError(404, 'Arrendatario no encontrado.')

    const hasContracts = state.rentalbiz.contracts.some((item) => item.tenant_id === tenantId)
    const hasPayments = state.rentalbiz.payments.some((item) => item.user_id === tenantId)
    if (hasContracts || hasPayments) {
      throw createError(409, 'No se puede eliminar el arrendatario porque tiene contratos o pagos asociados.')
    }

    state.rentalbiz.tenants.splice(tenantIndex, 1)
    return { success: true }
  }

  throw createError(404, `Ruta demo no implementada: ${method} ${path}`)
}

const mapAgendaAppointment = (appointment) => {
  const state = getState()
  const service = state.agendalab.services.find((item) => item.id === appointment.service_id) || null
  const clientRaw = state.agendalab.clients.find((item) => item.id === appointment.client_id) || null
  const client = mapAgendaClient(clientRaw)
  return {
    ...appointment,
    service,
    client,
    serviceId: appointment.service_id,
    clientId: appointment.client_id,
    startAtUtc: appointment.start_at_utc,
    endAtUtc: appointment.end_at_utc,
    createdAtUtc: appointment.created_at_utc
  }
}

const calculateWorkload = (dateString) => {
  const state = getState()
  const targetDate = toYmd(dateString || nowIso())
  const appointmentsForDate = state.agendalab.appointments.filter((appointment) => {
    if (appointment.status === 'cancelled') return false
    return toYmd(appointment.start_at_utc) === targetDate
  })

  const fallbackAppointments = (
    appointmentsForDate.length === 0 &&
    state.agendalab.services.length > 0 &&
    state.agendalab.clients.length > 0
  )
    ? [
        {
          id: `ag-workload-${targetDate}`,
          service_id: state.agendalab.services[0].id,
          client_id: state.agendalab.clients[0].id,
          start_at_utc: `${targetDate}T14:00:00.000Z`,
          end_at_utc: `${targetDate}T14:45:00.000Z`,
          status: 'scheduled',
          notes: 'Cita demostrativa del dia'
        }
      ]
    : []

  const effectiveAppointments = appointmentsForDate.length > 0
    ? appointmentsForDate
    : fallbackAppointments

  const occupied = effectiveAppointments.reduce((acc, item) => {
    const start = new Date(item.start_at_utc).getTime()
    const end = new Date(item.end_at_utc).getTime()
    const minutes = Math.max(0, (end - start) / 60000)
    return acc + minutes
  }, 0)

  const schedule = state.agendalab.schedule || {}
  const [startHour = 8, startMinute = 0] = String(schedule.day_start || '08:00').split(':').map((value) => Number(value) || 0)
  const [endHour = 18, endMinute = 0] = String(schedule.day_end || '18:00').split(':').map((value) => Number(value) || 0)
  const totalMinutesAvailable = Math.max(60, ((endHour * 60 + endMinute) - (startHour * 60 + startMinute)))

  const appointments = effectiveAppointments
    .map((appointment) => mapAgendaAppointment(appointment))
    .map((appointment) => ({
      appointmentId: appointment.id,
      serviceName: appointment.service?.name || 'Servicio',
      clientName: appointment.client?.fullName || 'Cliente',
      startAtUtc: appointment.startAtUtc,
      endAtUtc: appointment.endAtUtc,
      status: appointment.status,
      notes: appointment.notes || ''
    }))

  return {
    totalMinutesAvailable,
    totalMinutesOccupied: occupied,
    utilizationPercent: Number(((occupied / totalMinutesAvailable) * 100).toFixed(1)),
    appointments
  }
}

const computeMaterialTakeoff = (payload = {}) => {
  const areaM2 = Math.max(0, toNumber(payload.areaM2, 0))
  const depthM = Math.max(0, toNumber(payload.depthM, 0))
  const thicknessM = Math.max(0, toNumber(payload.thicknessM, 0))
  const lengthM = Math.max(0, toNumber(payload.lengthM, 0))
  const widthM = Math.max(0, toNumber(payload.widthM, 0))
  const heightM = Math.max(0, toNumber(payload.heightM, 0))
  const count = Math.max(0, toNumber(payload.count, 1))
  const openingsAreaM2 = Math.max(0, toNumber(payload.openingsAreaM2, 0))
  const unitsPerM2 = Math.max(0, toNumber(payload.unitsPerM2, 11.5))
  const mortarM3PerM2 = Math.max(0, toNumber(payload.mortarM3PerM2, 0.02))
  const tileAreaM2 = Math.max(0, toNumber(payload.tileAreaM2, 0))
  const wasteFactor = Math.max(0, toNumber(payload.wasteFactor, 0.1))
  const paintAreaM2 = Math.max(0, toNumber(payload.paintAreaM2, 0))
  const coats = Math.max(1, toNumber(payload.coats, 2))
  const coverageM2PerLiter = Math.max(0.1, toNumber(payload.coverageM2PerLiter, 10))
  const stuccoKgPerM2 = Math.max(0, toNumber(payload.stuccoKgPerM2, 4.5))

  const foundationConcreteM3 = areaM2 * depthM * thicknessM
  const structureConcreteM3 = lengthM * widthM * heightM * count
  const concreteM3 = foundationConcreteM3 + structureConcreteM3
  const steelKg = concreteM3 * 72
  const effectiveWallAreaM2 = Math.max(areaM2 - openingsAreaM2, 0)
  const blockUnits = effectiveWallAreaM2 * unitsPerM2 * (1 + wasteFactor)
  const mortarM3 = effectiveWallAreaM2 * mortarM3PerM2
  const tileM2 = tileAreaM2 * (1 + wasteFactor)
  const paintLiters = (paintAreaM2 * coats) / coverageM2PerLiter
  const stuccoKg = paintAreaM2 * stuccoKgPerM2
  const wasteReserveM3 = concreteM3 * wasteFactor

  return {
    concreteM3: Number(concreteM3.toFixed(2)),
    steelKg: Number(steelKg.toFixed(2)),
    blockUnits: Number(blockUnits.toFixed(2)),
    mortarM3: Number(mortarM3.toFixed(2)),
    tileM2: Number(tileM2.toFixed(2)),
    paintLiters: Number(paintLiters.toFixed(2)),
    stuccoKg: Number(stuccoKg.toFixed(2)),
    wasteReserveM3: Number(wasteReserveM3.toFixed(2))
  }
}

const handleMaterialCalculator = (path, method, body) => {
  const state = getState()

  if (path === '/api/material-calculator/status' && method === 'GET') {
    return { enabled: true }
  }

  if (path === '/api/material-calculator/projects' && method === 'GET') {
    return [...state.materialCalculator.projects]
      .sort((a, b) => new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0))
  }

  if (path === '/api/material-calculator/projects' && method === 'POST') {
    const project = {
      id: nextId('mcProject'),
      name: String(pick(body, 'name') || 'Proyecto demo').trim() || 'Proyecto demo',
      projectType: pick(body, 'projectType', 'project_type') || 'casa',
      description: pick(body, 'description') || '',
      countryCode: String(pick(body, 'countryCode', 'country_code') || 'CO').toUpperCase(),
      currencyCode: String(pick(body, 'currencyCode', 'currency_code') || 'COP').toUpperCase(),
      unitSystem: pick(body, 'unitSystem', 'unit_system') || 'metric',
      timeZone: pick(body, 'timeZone', 'time_zone') || 'America/Bogota',
      rulesetId: pick(body, 'rulesetId', 'ruleset_id') || state.materialCalculator.rulesets[0]?.id || null,
      status: 'draft',
      createdAt: nowIso(),
      updatedAt: nowIso(),
      lastCalculatedAt: null
    }
    state.materialCalculator.projects.unshift(project)
    return project
  }

  const projectByIdMatch = path.match(/^\/api\/material-calculator\/projects\/([^/]+)$/)
  if (projectByIdMatch && method === 'GET') {
    const projectId = decodeURIComponent(projectByIdMatch[1])
    const project = state.materialCalculator.projects.find((item) => item.id === projectId)
    if (!project) throw createError(404, 'Proyecto no encontrado.')
    return project
  }
  if (projectByIdMatch && method === 'DELETE') {
    const projectId = decodeURIComponent(projectByIdMatch[1])
    state.materialCalculator.projects = state.materialCalculator.projects.filter((item) => item.id !== projectId)
    state.materialCalculator.inputs = state.materialCalculator.inputs.filter((item) => item.projectId !== projectId)
    state.materialCalculator.runs = state.materialCalculator.runs.filter((item) => item.projectId !== projectId)
    return { success: true }
  }

  const duplicateProjectMatch = path.match(/^\/api\/material-calculator\/projects\/([^/]+)\/duplicate$/)
  if (duplicateProjectMatch && method === 'POST') {
    const sourceProjectId = decodeURIComponent(duplicateProjectMatch[1])
    const source = state.materialCalculator.projects.find((item) => item.id === sourceProjectId)
    if (!source) throw createError(404, 'Proyecto no encontrado.')

    const duplicated = {
      ...source,
      id: nextId('mcProject'),
      name: `${source.name} (Copia)`,
      status: 'draft',
      lastCalculatedAt: null,
      createdAt: nowIso(),
      updatedAt: nowIso()
    }
    state.materialCalculator.projects.unshift(duplicated)

    const clonedInputs = state.materialCalculator.inputs
      .filter((item) => item.projectId === sourceProjectId)
      .map((item) => ({
        ...item,
        id: nextId('mcInput'),
        projectId: duplicated.id,
        updatedAt: nowIso()
      }))
    state.materialCalculator.inputs.unshift(...clonedInputs)

    return duplicated
  }

  const projectInputsMatch = path.match(/^\/api\/material-calculator\/projects\/([^/]+)\/inputs$/)
  if (projectInputsMatch && method === 'GET') {
    const projectId = decodeURIComponent(projectInputsMatch[1])
    const project = state.materialCalculator.projects.find((item) => item.id === projectId)
    if (!project) throw createError(404, 'Proyecto no encontrado.')
    return state.materialCalculator.inputs.filter((item) => item.projectId === projectId)
  }
  if (projectInputsMatch && method === 'POST') {
    const projectId = decodeURIComponent(projectInputsMatch[1])
    const project = state.materialCalculator.projects.find((item) => item.id === projectId)
    if (!project) throw createError(404, 'Proyecto no encontrado.')

    const sectionKey = pick(body, 'sectionKey', 'section_key') || ''
    if (!sectionKey) throw createError(400, 'sectionKey es obligatorio.')

    const inputJson = pick(body, 'inputJson', 'input_json') || '{}'
    const existing = state.materialCalculator.inputs.find((item) => item.projectId === projectId && item.sectionKey === sectionKey)
    if (existing) {
      existing.inputJson = String(inputJson)
      existing.updatedAt = nowIso()
      project.updatedAt = nowIso()
      return existing
    }

    const created = {
      id: nextId('mcInput'),
      projectId,
      sectionKey,
      inputJson: String(inputJson),
      updatedAt: nowIso()
    }
    state.materialCalculator.inputs.unshift(created)
    project.updatedAt = nowIso()
    return created
  }

  const projectTakeoffMatch = path.match(/^\/api\/material-calculator\/projects\/([^/]+)\/takeoff$/)
  if (projectTakeoffMatch && method === 'POST') {
    const projectId = decodeURIComponent(projectTakeoffMatch[1])
    const project = state.materialCalculator.projects.find((item) => item.id === projectId)
    if (!project) throw createError(404, 'Proyecto no encontrado.')

    const results = computeMaterialTakeoff(body)
    const run = {
      id: nextId('mcRun'),
      projectId,
      createdAt: nowIso(),
      resultsJson: JSON.stringify(results)
    }

    state.materialCalculator.runs.unshift(run)
    project.status = 'calculated'
    project.lastCalculatedAt = run.createdAt
    project.updatedAt = run.createdAt

    return results
  }

  const projectRunsMatch = path.match(/^\/api\/material-calculator\/projects\/([^/]+)\/runs$/)
  if (projectRunsMatch && method === 'GET') {
    const projectId = decodeURIComponent(projectRunsMatch[1])
    const project = state.materialCalculator.projects.find((item) => item.id === projectId)
    if (!project) throw createError(404, 'Proyecto no encontrado.')

    return [...state.materialCalculator.runs]
      .filter((item) => item.projectId === projectId)
      .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
  }

  if (path === '/api/material-calculator/rulesets' && method === 'GET') {
    return state.materialCalculator.rulesets.map((item) => ({
      id: item.id,
      ruleKey: item.ruleKey,
      version: item.version,
      isActive: Boolean(item.isActive),
      sourceTitle: item.sourceTitle
    }))
  }

  const rulesetByIdMatch = path.match(/^\/api\/material-calculator\/rulesets\/([^/]+)$/)
  if (rulesetByIdMatch && method === 'GET') {
    const rulesetId = decodeURIComponent(rulesetByIdMatch[1])
    const ruleset = state.materialCalculator.rulesets.find((item) => item.id === rulesetId)
    if (!ruleset) throw createError(404, 'Ruleset no encontrado.')
    return ruleset
  }

  const rulesetOverrideMatch = path.match(/^\/api\/material-calculator\/rulesets\/([^/]+)\/parameters\/([^/]+)$/)
  if (rulesetOverrideMatch && method === 'PUT') {
    const rulesetId = decodeURIComponent(rulesetOverrideMatch[1])
    const paramKey = decodeURIComponent(rulesetOverrideMatch[2])
    const ruleset = state.materialCalculator.rulesets.find((item) => item.id === rulesetId)
    if (!ruleset) throw createError(404, 'Ruleset no encontrado.')

    const nextValue = toNumber(pick(body, 'paramValue', 'param_value'), 0)
    const existing = (ruleset.parameters || []).find((item) => item.paramKey === paramKey)
    if (existing) {
      existing.paramValue = nextValue
    } else {
      ruleset.parameters = ruleset.parameters || []
      ruleset.parameters.push({
        paramKey,
        paramValue: nextValue,
        unit: pick(body, 'unit') || ''
      })
    }
    return ruleset
  }

  if (path === '/api/material-calculator/catalog' && method === 'GET') {
    return [...state.materialCalculator.catalog]
      .sort((a, b) => String(a.sku || '').localeCompare(String(b.sku || '')))
  }

  throw createError(404, `Ruta demo no implementada: ${method} ${path}`)
}

const getRentalRate = (equipment, unit) => {
  if (!equipment) return 0
  const normalized = String(unit || 'day').toLowerCase()
  if (normalized === 'hour') return toNumber(equipment.hourly_rate, 0)
  if (normalized === 'week') return toNumber(equipment.weekly_rate, 0)
  if (normalized === 'month') return toNumber(equipment.monthly_rate, 0)
  return toNumber(equipment.daily_rate, 0)
}

const computeOrderTotals = (startUtc, endUtc, unitRate, rateUnit, vatRatePct) => {
  const start = new Date(startUtc).getTime()
  const end = new Date(endUtc).getTime()
  const hours = Math.max(1, (end - start) / 3600000)

  let quantity = 1
  const normalized = String(rateUnit || 'day').toLowerCase()
  if (normalized === 'hour') quantity = Math.max(1, Math.ceil(hours))
  else if (normalized === 'week') quantity = Math.max(1, Math.ceil(hours / (24 * 7)))
  else if (normalized === 'month') quantity = Math.max(1, Math.ceil(hours / (24 * 30)))
  else quantity = Math.max(1, Math.ceil(hours / 24))

  const subtotal = Math.round(toNumber(unitRate, 0) * quantity)
  const vatAmount = Math.round(subtotal * (toNumber(vatRatePct, 0) / 100))
  const totalAmount = subtotal + vatAmount

  return { quantity, subtotal, vatAmount, totalAmount }
}

const intervalsOverlap = (startA, endA, startB, endB) =>
  new Date(startA).getTime() < new Date(endB).getTime() &&
  new Date(startB).getTime() < new Date(endA).getTime()

const getAuthorityCode = (country) => {
  const normalized = String(country || '').trim().toLowerCase()
  if (normalized === 'mexico') return 'SAT'
  if (normalized === 'peru') return 'SUNAT'
  return 'DIAN'
}

const computeRentalTechDashboard = (state) => {
  const equipments = state.rentaltech.equipments || []
  const maintenance = state.rentaltech.maintenanceOrders || []

  const utilizationTime = equipments.length
    ? Math.round(equipments.reduce((acc, item) => acc + toNumber(item.utilization_time_pct, 0), 0) / equipments.length)
    : 0
  const utilizationFinancial = equipments.length
    ? Math.round(equipments.reduce((acc, item) => acc + toNumber(item.utilization_financial_pct, 0), 0) / equipments.length)
    : 0

  const inactiveEquipment = equipments.filter((item) => String(item.status || '').toLowerCase() === 'available').length
  const openMaintenanceCost = maintenance
    .filter((item) => String(item.status || '').toLowerCase() !== 'closed')
    .reduce((acc, item) => acc + toNumber(item.estimated_cost, 0), 0)
  const assetBase = equipments.reduce((acc, item) => acc + toNumber(item.asset_value, 0), 0)

  return {
    utilization_financial_pct: utilizationFinancial,
    utilization_time_pct: utilizationTime,
    inactive_equipment: inactiveEquipment,
    preventive_roi_pct: 27,
    capex_projected: Math.round(assetBase * 0.11),
    opex_projected: Math.round(openMaintenanceCost * 2.4),
    metric_claims: {
      monthly_roi_estimate: Math.round(assetBase * 0.014)
    }
  }
}

const refreshRentalTechStatuses = (state) => {
  const now = Date.now()
  const maintenanceByEquipment = new Map()
  for (const row of state.rentaltech.maintenanceOrders || []) {
    if (String(row.status || '').toLowerCase() === 'closed') continue
    maintenanceByEquipment.set(row.equipment_id, true)
  }

  for (const equipment of state.rentaltech.equipments || []) {
    const activeOrder = (state.rentaltech.orders || []).some((order) =>
      order.equipment_id === equipment.id &&
      new Date(order.start_utc).getTime() <= now &&
      new Date(order.end_utc).getTime() >= now
    )

    if (maintenanceByEquipment.get(equipment.id)) equipment.status = 'maintenance'
    else if (activeOrder) equipment.status = 'rented'
    else equipment.status = 'available'
  }
}

const findLifeSheetByEquipment = (state, equipmentId) =>
  (state.rentaltech.lifeSheets || []).find((item) => item.equipment_id === equipmentId) || null

const handleRentalTech = (path, method, body) => {
  const state = getState()
  refreshRentalTechStatuses(state)

  if (path === '/api/rentaltech/dashboard' && method === 'GET') {
    return computeRentalTechDashboard(state)
  }

  if (path === '/api/rentaltech/customers' && method === 'GET') {
    return state.rentaltech.customers
  }
  if (path === '/api/rentaltech/customers' && method === 'POST') {
    const customerId = pick(body, 'id')
    const existing = customerId
      ? state.rentaltech.customers.find((item) => item.id === customerId)
      : null

    if (existing) {
      Object.assign(existing, {
        company_name: pick(body, 'companyName', 'company_name') || existing.company_name,
        contact_name: pick(body, 'contactName', 'contact_name') || existing.contact_name,
        document_number: pick(body, 'documentNumber', 'document_number') || existing.document_number,
        email: pick(body, 'email') || existing.email,
        phone: pick(body, 'phone') || existing.phone,
        country: pick(body, 'country') || existing.country,
        city: pick(body, 'city') || existing.city,
        address: pick(body, 'address') || existing.address,
        tier: pick(body, 'tier') || existing.tier,
        is_active: pick(body, 'isActive', 'is_active') ?? existing.is_active
      })
      return existing
    }

    const customer = {
      id: nextId('rtCustomer'),
      company_name: pick(body, 'companyName', 'company_name') || 'Cliente demo',
      contact_name: pick(body, 'contactName', 'contact_name') || '',
      document_number: pick(body, 'documentNumber', 'document_number') || '',
      email: pick(body, 'email') || '',
      phone: pick(body, 'phone') || '',
      country: pick(body, 'country') || 'Colombia',
      city: pick(body, 'city') || '',
      address: pick(body, 'address') || '',
      tier: pick(body, 'tier') || 'standard',
      is_active: pick(body, 'isActive', 'is_active') ?? true
    }
    state.rentaltech.customers.unshift(customer)
    return customer
  }

  const customerByIdMatch = path.match(/^\/api\/rentaltech\/customers\/([^/]+)$/)
  if (customerByIdMatch && method === 'GET') {
    const customerId = decodeURIComponent(customerByIdMatch[1])
    const customer = state.rentaltech.customers.find((item) => item.id === customerId)
    if (!customer) throw createError(404, 'Cliente no encontrado.')
    return customer
  }
  if (customerByIdMatch && method === 'DELETE') {
    const customerId = decodeURIComponent(customerByIdMatch[1])
    state.rentaltech.customers = state.rentaltech.customers.filter((item) => item.id !== customerId)
    return { success: true }
  }

  if (path === '/api/rentaltech/equipments' && method === 'GET') {
    return state.rentaltech.equipments
  }
  if (path === '/api/rentaltech/equipments' && method === 'POST') {
    const equipmentId = pick(body, 'id')
    const existing = equipmentId
      ? state.rentaltech.equipments.find((item) => item.id === equipmentId)
      : null

    if (existing) {
      Object.assign(existing, {
        code: pick(body, 'code') || existing.code,
        name: pick(body, 'name') || existing.name,
        type: pick(body, 'type') || existing.type,
        brand: pick(body, 'brand') || existing.brand,
        model: pick(body, 'model') || existing.model,
        serial_number: pick(body, 'serialNumber', 'serial_number') || existing.serial_number,
        year: toNumber(pick(body, 'year'), existing.year),
        asset_value: toNumber(pick(body, 'assetValue', 'asset_value'), existing.asset_value),
        hourly_rate: toNumber(pick(body, 'hourlyRate', 'hourly_rate'), existing.hourly_rate),
        daily_rate: toNumber(pick(body, 'dailyRate', 'daily_rate'), existing.daily_rate),
        weekly_rate: toNumber(pick(body, 'weeklyRate', 'weekly_rate'), existing.weekly_rate),
        monthly_rate: toNumber(pick(body, 'monthlyRate', 'monthly_rate'), existing.monthly_rate),
        lat: toNumber(pick(body, 'lat'), existing.lat),
        lng: toNumber(pick(body, 'lng'), existing.lng)
      })
      return existing
    }

    const equipment = {
      id: nextId('rtEquipment'),
      code: pick(body, 'code') || generateCode('EQ'),
      name: pick(body, 'name') || 'Equipo demo',
      type: pick(body, 'type') || 'general',
      brand: pick(body, 'brand') || '',
      model: pick(body, 'model') || '',
      serial_number: pick(body, 'serialNumber', 'serial_number') || '',
      year: toNumber(pick(body, 'year'), new Date().getFullYear()),
      asset_value: toNumber(pick(body, 'assetValue', 'asset_value'), 0),
      hourly_rate: toNumber(pick(body, 'hourlyRate', 'hourly_rate'), 0),
      daily_rate: toNumber(pick(body, 'dailyRate', 'daily_rate'), 0),
      weekly_rate: toNumber(pick(body, 'weeklyRate', 'weekly_rate'), 0),
      monthly_rate: toNumber(pick(body, 'monthlyRate', 'monthly_rate'), 0),
      lat: toNumber(pick(body, 'lat'), 0),
      lng: toNumber(pick(body, 'lng'), 0),
      status: 'available',
      utilization_time_pct: 0,
      utilization_financial_pct: 0
    }
    state.rentaltech.equipments.unshift(equipment)
    return equipment
  }

  const equipmentByIdMatch = path.match(/^\/api\/rentaltech\/equipments\/([^/]+)$/)
  if (equipmentByIdMatch && method === 'GET') {
    const equipmentId = decodeURIComponent(equipmentByIdMatch[1])
    const equipment = state.rentaltech.equipments.find((item) => item.id === equipmentId)
    if (!equipment) throw createError(404, 'Equipo no encontrado.')
    return equipment
  }
  if (equipmentByIdMatch && method === 'DELETE') {
    const equipmentId = decodeURIComponent(equipmentByIdMatch[1])
    state.rentaltech.equipments = state.rentaltech.equipments.filter((item) => item.id !== equipmentId)
    state.rentaltech.lifeSheets = state.rentaltech.lifeSheets.filter((item) => item.equipment_id !== equipmentId)
    state.rentaltech.orders = state.rentaltech.orders.filter((item) => item.equipment_id !== equipmentId)
    state.rentaltech.maintenanceOrders = state.rentaltech.maintenanceOrders.filter((item) => item.equipment_id !== equipmentId)
    state.rentaltech.telemetry = state.rentaltech.telemetry.filter((item) => item.equipment_id !== equipmentId)
    state.rentaltech.inspections = state.rentaltech.inspections.filter((item) => item.equipment_id !== equipmentId)
    return { success: true }
  }

  const lifeSheetMatch = path.match(/^\/api\/rentaltech\/equipments\/([^/]+)\/life-sheet$/)
  if (lifeSheetMatch && method === 'GET') {
    const equipmentId = decodeURIComponent(lifeSheetMatch[1])
    const row = findLifeSheetByEquipment(state, equipmentId)
    return row || null
  }
  if (lifeSheetMatch && method === 'POST') {
    const equipmentId = decodeURIComponent(lifeSheetMatch[1])
    const equipment = state.rentaltech.equipments.find((item) => item.id === equipmentId)
    if (!equipment) throw createError(404, 'Equipo no encontrado.')

    const existing = findLifeSheetByEquipment(state, equipmentId)
    const next = {
      id: existing?.id || nextId('rtLife'),
      equipment_id: equipmentId,
      acquisition_date_utc: pick(body, 'acquisitionDateUtc', 'acquisition_date_utc') || existing?.acquisition_date_utc || nowIso(),
      acquisition_cost: toNumber(pick(body, 'acquisitionCost', 'acquisition_cost'), existing?.acquisition_cost || 0),
      current_engine_hours: toNumber(pick(body, 'currentEngineHours', 'current_engine_hours'), existing?.current_engine_hours || 0),
      last_preventive_maintenance_utc: pick(body, 'lastPreventiveMaintenanceUtc', 'last_preventive_maintenance_utc') || existing?.last_preventive_maintenance_utc || null,
      last_corrective_maintenance_utc: pick(body, 'lastCorrectiveMaintenanceUtc', 'last_corrective_maintenance_utc') || existing?.last_corrective_maintenance_utc || null,
      insurance_policy: pick(body, 'insurancePolicy', 'insurance_policy') || existing?.insurance_policy || '',
      technical_specs_json: pick(body, 'technicalSpecsJson', 'technical_specs_json') || existing?.technical_specs_json || '[]',
      documents_json: pick(body, 'documentsJson', 'documents_json') || existing?.documents_json || '[]',
      notes: pick(body, 'notes') || existing?.notes || '',
      events: Array.isArray(pick(body, 'events')) ? pick(body, 'events') : (existing?.events || [])
    }

    state.rentaltech.lifeSheets = state.rentaltech.lifeSheets.filter((item) => item.equipment_id !== equipmentId)
    state.rentaltech.lifeSheets.unshift(next)
    return next
  }

  if (path === '/api/rentaltech/rental-orders' && method === 'GET') {
    return [...state.rentaltech.orders]
      .sort((a, b) => new Date(b.created_at_utc || 0) - new Date(a.created_at_utc || 0))
  }

  if (path === '/api/rentaltech/rental-orders/validate' && method === 'POST') {
    const equipmentId = pick(body, 'equipmentId', 'equipment_id')
    const startUtc = pick(body, 'startUtc', 'start_utc')
    const endUtc = pick(body, 'endUtc', 'end_utc')
    const ignoreOrderId = pick(body, 'ignoreOrderId', 'ignore_order_id')

    const conflicts = state.rentaltech.orders.filter((item) =>
      item.equipment_id === equipmentId &&
      item.id !== ignoreOrderId &&
      intervalsOverlap(startUtc, endUtc, item.start_utc, item.end_utc)
    )

    return {
      allowed: conflicts.length === 0,
      message: conflicts.length === 0
        ? 'Equipo disponible para el rango solicitado.'
        : 'El equipo ya tiene una reserva/contrato en el rango seleccionado.',
      conflicts: conflicts.map((item) => ({
        orderId: item.id,
        contractNumber: item.contract_number,
        startUtc: item.start_utc,
        endUtc: item.end_utc
      }))
    }
  }

  if (path === '/api/rentaltech/rental-orders' && method === 'POST') {
    const equipmentId = pick(body, 'equipmentId', 'equipment_id')
    const equipment = state.rentaltech.equipments.find((item) => item.id === equipmentId)
    if (!equipment) throw createError(404, 'Equipo no encontrado.')

    const startUtc = pick(body, 'startUtc', 'start_utc') || addHoursIso(1)
    const endUtc = pick(body, 'endUtc', 'end_utc') || addHoursIso(25)
    const rateUnit = pick(body, 'rateUnit', 'rate_unit') || 'day'
    const unitRate = getRentalRate(equipment, rateUnit)
    const vatRatePct = toNumber(pick(body, 'vatRatePct', 'vat_rate_pct'), 19)
    const totals = computeOrderTotals(startUtc, endUtc, unitRate, rateUnit, vatRatePct)

    const order = {
      id: nextId('rtOrder'),
      quote_number: `Q-2026-${String(state.counters.rtOrder).padStart(4, '0')}`,
      contract_number: `RT-CTR-2026-${String(state.counters.rtOrder).padStart(4, '0')}`,
      equipment_id: equipmentId,
      customer_id: pick(body, 'customerId', 'customer_id') || null,
      customer_name: pick(body, 'customerName', 'customer_name') || 'Cliente demo',
      customer_tier: pick(body, 'customerTier', 'customer_tier') || 'standard',
      start_utc: startUtc,
      end_utc: endUtc,
      rate_unit: rateUnit,
      unit_rate: unitRate,
      vat_rate_pct: vatRatePct,
      subtotal: totals.subtotal,
      vat_amount: totals.vatAmount,
      total_amount: totals.totalAmount,
      signed: false,
      signer_name: null,
      signed_at_utc: null,
      created_at_utc: nowIso(),
      status: new Date(startUtc).getTime() <= Date.now() ? 'active' : 'quoted'
    }

    state.rentaltech.orders.unshift(order)
    refreshRentalTechStatuses(state)
    return order
  }

  const orderByIdMatch = path.match(/^\/api\/rentaltech\/rental-orders\/([^/]+)$/)
  if (orderByIdMatch && method === 'PUT') {
    const orderId = decodeURIComponent(orderByIdMatch[1])
    const order = state.rentaltech.orders.find((item) => item.id === orderId)
    if (!order) throw createError(404, 'Contrato no encontrado.')

    const equipmentId = pick(body, 'equipmentId', 'equipment_id') || order.equipment_id
    const equipment = state.rentaltech.equipments.find((item) => item.id === equipmentId)
    if (!equipment) throw createError(404, 'Equipo no encontrado.')

    const startUtc = pick(body, 'startUtc', 'start_utc') || order.start_utc
    const endUtc = pick(body, 'endUtc', 'end_utc') || order.end_utc
    const rateUnit = pick(body, 'rateUnit', 'rate_unit') || order.rate_unit
    const unitRate = getRentalRate(equipment, rateUnit)
    const vatRatePct = toNumber(pick(body, 'vatRatePct', 'vat_rate_pct'), order.vat_rate_pct)
    const totals = computeOrderTotals(startUtc, endUtc, unitRate, rateUnit, vatRatePct)

    Object.assign(order, {
      equipment_id: equipmentId,
      customer_id: pick(body, 'customerId', 'customer_id') ?? order.customer_id,
      customer_name: pick(body, 'customerName', 'customer_name') || order.customer_name,
      customer_tier: pick(body, 'customerTier', 'customer_tier') || order.customer_tier,
      start_utc: startUtc,
      end_utc: endUtc,
      rate_unit: rateUnit,
      unit_rate: unitRate,
      vat_rate_pct: vatRatePct,
      subtotal: totals.subtotal,
      vat_amount: totals.vatAmount,
      total_amount: totals.totalAmount
    })

    refreshRentalTechStatuses(state)
    return order
  }

  const signOrderMatch = path.match(/^\/api\/rentaltech\/rental-orders\/([^/]+)\/sign$/)
  if (signOrderMatch && method === 'POST') {
    const orderId = decodeURIComponent(signOrderMatch[1])
    const order = state.rentaltech.orders.find((item) => item.id === orderId)
    if (!order) throw createError(404, 'Contrato no encontrado.')

    order.signed = true
    order.signer_name = pick(body, 'signerName', 'signer_name') || 'Firma Demo'
    order.signed_at_utc = nowIso()
    order.status = 'active'
    refreshRentalTechStatuses(state)
    return order
  }

  if (path === '/api/rentaltech/availability' && method === 'GET') {
    const now = Date.now()
    return state.rentaltech.equipments.map((equipment) => {
      const active = state.rentaltech.orders.find((order) =>
        order.equipment_id === equipment.id &&
        new Date(order.start_utc).getTime() <= now &&
        new Date(order.end_utc).getTime() >= now
      )
      if (!active) return null
      return {
        id: `${equipment.id}-block`,
        equipment_id: equipment.id,
        order_id: active.id,
        start_utc: active.start_utc,
        end_utc: active.end_utc
      }
    }).filter(Boolean)
  }

  if (path === '/api/rentaltech/maintenance-orders' && method === 'GET') {
    return [...state.rentaltech.maintenanceOrders]
      .sort((a, b) => new Date(b.created_at_utc || 0) - new Date(a.created_at_utc || 0))
  }
  if (path === '/api/rentaltech/maintenance-orders/auto-generate' && method === 'POST') {
    const openByEquipment = new Set(
      state.rentaltech.maintenanceOrders
        .filter((item) => String(item.status || '').toLowerCase() !== 'closed')
        .map((item) => item.equipment_id)
    )

    for (const equipment of state.rentaltech.equipments) {
      if (openByEquipment.has(equipment.id)) continue
      state.rentaltech.maintenanceOrders.unshift({
        id: nextId('rtMaintenance'),
        equipment_id: equipment.id,
        type: 'preventivo',
        trigger_source: 'auto_horas_motor',
        estimated_cost: Math.round(toNumber(equipment.asset_value, 0) * 0.0025),
        status: 'open',
        created_at_utc: nowIso()
      })
    }
    refreshRentalTechStatuses(state)
    return state.rentaltech.maintenanceOrders
  }

  if (path === '/api/rentaltech/telemetry/latest' && method === 'GET') {
    return [...state.rentaltech.telemetry]
      .sort((a, b) => new Date(b.created_at_utc || 0) - new Date(a.created_at_utc || 0))
  }
  if (path === '/api/rentaltech/telemetry/simulate' && method === 'POST') {
    const equipmentId = pick(body, 'equipmentId', 'equipment_id')
    const equipment = state.rentaltech.equipments.find((item) => item.id === equipmentId)
    if (!equipment) throw createError(404, 'Equipo no encontrado.')

    const lat = toNumber(pick(body, 'lat'), equipment.lat || 0)
    const lng = toNumber(pick(body, 'lng'), equipment.lng || 0)
    const geofenceAlert = lat < 3.3 || lat > 6.7 || lng < -76.9 || lng > -73.3

    const telemetry = {
      id: nextId('rtTelemetry'),
      equipment_id: equipmentId,
      engine_hours: toNumber(pick(body, 'engineHours', 'engine_hours'), 0),
      lat,
      lng,
      temperature_c: toNumber(pick(body, 'temperatureC', 'temperature_c'), 0),
      vibration_mm_s: toNumber(pick(body, 'vibrationMmS', 'vibration_mm_s'), 0),
      geofence_alert: geofenceAlert,
      created_at_utc: nowIso()
    }

    equipment.lat = lat
    equipment.lng = lng
    state.rentaltech.telemetry.unshift(telemetry)
    return telemetry
  }

  if (path === '/api/rentaltech/inspections' && method === 'GET') {
    return [...state.rentaltech.inspections]
      .sort((a, b) => new Date(b.created_at_utc || 0) - new Date(a.created_at_utc || 0))
  }
  if (path === '/api/rentaltech/inspections' && method === 'POST') {
    const equipmentId = pick(body, 'equipmentId', 'equipment_id')
    const equipment = state.rentaltech.equipments.find((item) => item.id === equipmentId)
    if (!equipment) throw createError(404, 'Equipo no encontrado.')

    const inspectionId = nextId('rtInspection')
    const inspection = {
      id: inspectionId,
      equipment_id: equipmentId,
      rental_order_id: pick(body, 'rentalOrderId', 'rental_order_id') || null,
      type: pick(body, 'type') || 'salida',
      checklist_json: pick(body, 'checklistJson', 'checklist_json') || '[]',
      photos_json: pick(body, 'photosJson', 'photos_json') || '[]',
      signature_name: pick(body, 'signatureName', 'signature_name') || 'Supervisor Demo',
      pdf_report_url: `data:text/plain;charset=utf-8,${encodeURIComponent(`Acta demo ${inspectionId}`)}`,
      created_at_utc: nowIso()
    }
    state.rentaltech.inspections.unshift(inspection)
    return inspection
  }

  if (path === '/api/rentaltech/billing/close-period' && method === 'POST') {
    const country = pick(body, 'country') || 'colombia'
    const vatRatePct = toNumber(pick(body, 'vatRatePct', 'vat_rate_pct'), 19)
    const authorityCode = getAuthorityCode(country)
    const signedOrders = state.rentaltech.orders.filter((item) => item.signed)

    const invoices = signedOrders.map((order) => {
      const subtotal = toNumber(order.subtotal, 0)
      const vatAmount = Math.round(subtotal * (vatRatePct / 100))
      const total = subtotal + vatAmount
      return {
        id: nextId('rtInvoice'),
        authority_code: authorityCode,
        number: `${authorityCode}-F-${String(state.counters.rtInvoice).padStart(4, '0')}`,
        subtotal,
        vat_amount: vatAmount,
        total,
        status: 'issued',
        country,
        emitted_at_utc: nowIso()
      }
    })

    state.rentaltech.invoices = invoices
    return invoices
  }

  const failureScoreMatch = path.match(/^\/api\/rentaltech\/predictive\/failure-score\/([^/]+)$/)
  if (failureScoreMatch && method === 'GET') {
    const equipmentId = decodeURIComponent(failureScoreMatch[1])
    const latest = [...state.rentaltech.telemetry]
      .filter((item) => item.equipment_id === equipmentId)
      .sort((a, b) => new Date(b.created_at_utc || 0) - new Date(a.created_at_utc || 0))[0]

    const openMaintenance = state.rentaltech.maintenanceOrders.some((item) =>
      item.equipment_id === equipmentId && String(item.status || '').toLowerCase() !== 'closed'
    )

    const vibration = toNumber(latest?.vibration_mm_s, 5)
    const temperature = toNumber(latest?.temperature_c, 80)
    const geofencePenalty = latest?.geofence_alert ? 15 : 0
    const maintenancePenalty = openMaintenance ? 10 : 0

    const scoreRaw = Math.round(vibration * 7 + Math.max(temperature - 70, 0) * 1.1 + geofencePenalty + maintenancePenalty)
    const riskScore = Math.max(5, Math.min(98, scoreRaw))

    const recommendation = riskScore >= 80
      ? 'Programar mantenimiento correctivo prioritario y sacar de operacion temporal.'
      : riskScore >= 55
        ? 'Agendar mantenimiento preventivo en las proximas 48 horas y monitorear telemetria.'
        : 'Operacion estable. Mantener plan preventivo y seguimiento semanal.'

    return {
      equipment_id: equipmentId,
      risk_score: riskScore,
      recommendation,
      generated_at_utc: nowIso()
    }
  }

  throw createError(404, `Ruta demo no implementada: ${method} ${path}`)
}

const handleAgendaLab = (path, method, searchParams, body) => {
  const state = getState()

  if (path === '/api/appointments/services' && method === 'GET') return state.agendalab.services
  if (path === '/api/appointments/services' && method === 'POST') {
    const item = {
      id: nextId('agendaService'),
      name: pick(body, 'name') || 'Nuevo servicio',
      duration_minutes: toNumber(pick(body, 'duration_minutes', 'durationMinutes'), 30),
      price: toNumber(pick(body, 'price'), 0),
      is_active: pick(body, 'is_active', 'isActive') ?? true
    }
    state.agendalab.services.push(item)
    return item
  }

  const serviceByIdMatch = path.match(/^\/api\/appointments\/services\/([^/]+)$/)
  if (serviceByIdMatch && method === 'PUT') {
    const service = state.agendalab.services.find((item) => item.id === serviceByIdMatch[1])
    if (!service) throw createError(404, 'Servicio no encontrado.')
    Object.assign(service, {
      ...service,
      ...body,
      duration_minutes: toNumber(pick(body, 'duration_minutes', 'durationMinutes'), service.duration_minutes),
      price: toNumber(pick(body, 'price'), service.price)
    })
    return service
  }
  if (serviceByIdMatch && method === 'DELETE') {
    state.agendalab.services = state.agendalab.services.filter((item) => item.id !== serviceByIdMatch[1])
    state.agendalab.appointments = state.agendalab.appointments.filter((item) => item.service_id !== serviceByIdMatch[1])
    return { success: true }
  }

  if (path === '/api/appointments/schedule' && method === 'GET') return state.agendalab.schedule
  if (path === '/api/appointments/schedule' && method === 'PUT') {
    state.agendalab.schedule = { ...state.agendalab.schedule, ...body }
    return state.agendalab.schedule
  }

  if (path === '/api/appointments/public-booking-settings' && method === 'GET') {
    return state.agendalab.public_booking_settings || {}
  }
  if (path === '/api/appointments/public-booking-settings' && method === 'PUT') {
    state.agendalab.public_booking_settings = {
      ...(state.agendalab.public_booking_settings || {}),
      ...body,
      is_enabled: pick(body, 'is_enabled', 'isEnabled') ?? state.agendalab.public_booking_settings?.is_enabled ?? true,
      public_agenda_url: pick(body, 'public_agenda_url', 'publicAgendaUrl') || state.agendalab.public_booking_settings?.public_agenda_url || '/public/agendalab/demo',
      display_name: pick(body, 'display_name', 'displayName') || state.agendalab.public_booking_settings?.display_name || 'AgendaLab Demo',
      description: pick(body, 'description') ?? state.agendalab.public_booking_settings?.description ?? '',
      nequi_key: pick(body, 'nequi_key', 'nequiKey') ?? state.agendalab.public_booking_settings?.nequi_key ?? '',
      nequi_key_type: pick(body, 'nequi_key_type', 'nequiKeyType') ?? state.agendalab.public_booking_settings?.nequi_key_type ?? 'telefono'
    }
    return state.agendalab.public_booking_settings
  }

  if (path === '/api/appointments/clients' && method === 'GET') {
    return state.agendalab.clients.map(mapAgendaClient)
  }
  if (path === '/api/appointments/clients' && method === 'POST') {
    const fullName = pick(body, 'full_name', 'fullName') || 'Nuevo cliente'
    const client = {
      id: nextId('agendaClient'),
      full_name: fullName,
      fullName,
      email: pick(body, 'email') || '',
      phone: pick(body, 'phone') || '',
      notes: pick(body, 'notes') || '',
      invitation_expires_at_utc: pick(body, 'invitation_expires_at_utc', 'invitationExpiresAtUtc') || null,
      invitation_is_one_time: pick(body, 'invitation_is_one_time', 'invitationIsOneTime') ?? false,
      invitation_is_active: pick(body, 'invitation_is_active', 'invitationIsActive') ?? true,
      invitation_code: generateCode('AG'),
      last_visit_at: nowIso()
    }
    state.agendalab.clients.unshift(client)
    return mapAgendaClient(client)
  }

  const clientByIdMatch = path.match(/^\/api\/appointments\/clients\/([^/]+)$/)
  if (clientByIdMatch && method === 'PUT') {
    const client = state.agendalab.clients.find((item) => item.id === clientByIdMatch[1])
    if (!client) throw createError(404, 'Cliente no encontrado.')

    const fullName = pick(body, 'full_name', 'fullName')
    Object.assign(client, {
      ...client,
      ...body,
      full_name: fullName || client.full_name,
      fullName: fullName || client.fullName || client.full_name,
      email: pick(body, 'email') ?? client.email,
      phone: pick(body, 'phone') ?? client.phone,
      notes: pick(body, 'notes') ?? client.notes,
      invitation_expires_at_utc: pick(body, 'invitation_expires_at_utc', 'invitationExpiresAtUtc') ?? client.invitation_expires_at_utc ?? null,
      invitation_is_one_time: pick(body, 'invitation_is_one_time', 'invitationIsOneTime') ?? client.invitation_is_one_time ?? false,
      invitation_is_active: pick(body, 'invitation_is_active', 'invitationIsActive') ?? client.invitation_is_active ?? true
    })

    return mapAgendaClient(client)
  }
  if (clientByIdMatch && method === 'DELETE') {
    const dependencyCount = state.agendalab.appointments.filter((item) => item.client_id === clientByIdMatch[1]).length
    if (dependencyCount > 0) throw createError(400, 'No se puede eliminar el cliente porque tiene dependencias asociadas.')

    state.agendalab.clients = state.agendalab.clients.filter((item) => item.id !== clientByIdMatch[1])
    return { success: true }
  }

  const clientInvitationMatch = path.match(/^\/api\/appointments\/clients\/([^/]+)\/invitation$/)
  if (clientInvitationMatch && method === 'POST') {
    const client = state.agendalab.clients.find((item) => item.id === clientInvitationMatch[1])
    if (!client) throw createError(404, 'Cliente no encontrado.')
    const dependencyCount = state.agendalab.appointments.filter((item) => item.client_id === client.id).length
    if (dependencyCount > 0) {
      throw createError(400, 'No se puede regenerar la invitacion porque el cliente ya tiene invitaciones o reservas asociadas.')
    }
    client.invitation_code = generateCode('AG')
    client.invitation_is_active = true
    return { invitationCode: client.invitation_code, clientId: client.id }
  }

  if (path === '/api/appointments/calendar' && method === 'GET') {
    const fromRaw = searchParams.get('from')
    const toRaw = searchParams.get('to')
    const from = fromRaw ? new Date(fromRaw) : new Date(addDaysIso(-1))
    const to = toRaw ? new Date(toRaw) : new Date(addDaysIso(30))
    return state.agendalab.appointments
      .filter((appointment) => {
        const start = new Date(appointment.start_at_utc)
        return start >= from && start <= to
      })
      .map(mapAgendaAppointment)
  }

  if (path === '/api/appointments' && method === 'POST') {
    const appointment = {
      id: nextId('agendaAppointment'),
      service_id: pick(body, 'service_id', 'serviceId') || '',
      client_id: pick(body, 'client_id', 'clientId') || '',
      start_at_utc: pick(body, 'start_at_utc', 'startAtUtc') || addDaysIso(1),
      end_at_utc: pick(body, 'end_at_utc', 'endAtUtc') || addDaysIso(1.02),
      status: pick(body, 'status') || 'scheduled',
      notes: pick(body, 'notes') || '',
      created_at_utc: nowIso()
    }
    state.agendalab.appointments.unshift(appointment)
    return mapAgendaAppointment(appointment)
  }

  const appointmentRescheduleMatch = path.match(/^\/api\/appointments\/([^/]+)\/reschedule$/)
  if (appointmentRescheduleMatch && method === 'POST') {
    const appointment = state.agendalab.appointments.find((item) => item.id === appointmentRescheduleMatch[1])
    if (!appointment) throw createError(404, 'Cita no encontrada.')
    appointment.start_at_utc = pick(body, 'start_at_utc', 'startAtUtc') || appointment.start_at_utc
    appointment.end_at_utc = pick(body, 'end_at_utc', 'endAtUtc') || appointment.end_at_utc
    appointment.notes = pick(body, 'notes') ?? appointment.notes
    appointment.status = 'rescheduled'
    return mapAgendaAppointment(appointment)
  }

  const appointmentCancelMatch = path.match(/^\/api\/appointments\/([^/]+)\/cancel$/)
  if (appointmentCancelMatch && method === 'POST') {
    const appointment = state.agendalab.appointments.find((item) => item.id === appointmentCancelMatch[1])
    if (!appointment) throw createError(404, 'Cita no encontrada.')
    appointment.status = 'cancelled'
    appointment.notes = pick(body, 'reason', 'notes') || appointment.notes
    return mapAgendaAppointment(appointment)
  }

  if (path === '/api/appointments/workload' && method === 'GET') {
    const date = searchParams.get('date') || nowIso()
    return calculateWorkload(date)
  }

  throw createError(404, `Ruta demo no implementada: ${method} ${path}`)
}

const handleUserEndpoints = (path, method, searchParams, body) => {
  const state = getState()

  if (path === '/api/user/profile' && method === 'GET') return state.rentalbiz.profile

  if (path === '/api/user/profile' && method === 'PUT') {
    state.rentalbiz.profile = {
      ...state.rentalbiz.profile,
      first_name: pick(body, 'firstName', 'first_name') ?? state.rentalbiz.profile.first_name,
      last_name: pick(body, 'lastName', 'last_name') ?? state.rentalbiz.profile.last_name,
      phone: pick(body, 'phone') ?? state.rentalbiz.profile.phone,
      document_number: pick(body, 'documentNumber', 'document_number') ?? state.rentalbiz.profile.document_number,
      address: pick(body, 'address') ?? state.rentalbiz.profile.address
    }
    return state.rentalbiz.profile
  }

  if (path === '/api/user/invitation-code' && method === 'POST') {
    const code = String(pick(body, 'code') || '').toUpperCase()
    state.rentalbiz.profile.property_invitation_code = code || null
    return { success: true, property_invitation_code: state.rentalbiz.profile.property_invitation_code }
  }

  if (path === '/api/user/products' && method === 'GET') return getDemoProducts()

  if (path === '/api/user/catalog/products' && method === 'GET') {
    const search = String(searchParams.get('search') || '').toLowerCase()
    return getDemoProducts()
      .filter((product) => {
        if (!search) return true
        return `${product.name} ${product.slug} ${product.description}`.toLowerCase().includes(search)
      })
      .map((product) => ({
        ...product,
        requiresLicense: false,
        frameworkType: 'react',
        hasActiveLicense: true,
        hasPendingRequest: false
      }))
  }

  if (path === '/api/user/license-requests' && method === 'GET') return state.licenseRequests
  if (path === '/api/user/license-requests' && method === 'POST') {
    const request = {
      id: nextId('licenseRequest'),
      userId: state.rentalbiz.profile.id,
      productId: pick(body, 'productId', 'product_id') || '',
      status: 'pending',
      requestNote: pick(body, 'note') || '',
      requestedAt: nowIso()
    }
    state.licenseRequests.unshift(request)
    return request
  }

  return null
}

const handleTelegramEndpoints = (path, method, body) => {
  const state = getState()

  if (path === '/api/integrations/telegram/status' && method === 'GET') {
    return {
      connected: Boolean(state.agendalab.telegram.connected),
      chatId: state.agendalab.telegram.chat_id || '',
      isEnabled: state.agendalab.telegram.is_enabled ?? false,
      updatedAtUtc: state.agendalab.telegram.updated_at_utc || nowIso()
    }
  }

  if (path === '/api/integrations/telegram/connect' && method === 'POST') {
    state.agendalab.telegram = {
      connected: true,
      chat_id: pick(body, 'chatId') || '',
      is_enabled: pick(body, 'isEnabled') ?? true,
      updated_at_utc: nowIso()
    }
    return {
      connected: true,
      chatId: state.agendalab.telegram.chat_id,
      isEnabled: state.agendalab.telegram.is_enabled,
      updatedAtUtc: state.agendalab.telegram.updated_at_utc
    }
  }

  if (path === '/api/integrations/telegram/test' && method === 'POST') {
    return {
      ok: true,
      message: 'Mensaje de prueba enviado en modo demo.'
    }
  }

  return null
}

export const handleDemoApiRequest = async (url, options = {}) => {
  const requestUrl = new URL(url, window.location.origin)
  const path = requestUrl.pathname
  const method = normalizeMethod(options.method)
  const searchParams = requestUrl.searchParams
  const body = parseBody(options)

  if (!path.startsWith('/api/')) return null

  if (path.startsWith('/api/rentalbiz/')) return clone(handleRentalBiz(path, method, searchParams, body))
  if (path.startsWith('/api/rentaltech/')) return clone(handleRentalTech(path, method, body))
  if (path.startsWith('/api/appointments')) return clone(handleAgendaLab(path, method, searchParams, body))
  if (path.startsWith('/api/material-calculator/')) return clone(handleMaterialCalculator(path, method, body))
  if (path.startsWith('/api/integrations/telegram')) {
    const response = handleTelegramEndpoints(path, method, body)
    return response ? clone(response) : null
  }
  if (path.startsWith('/api/user/')) {
    const response = handleUserEndpoints(path, method, searchParams, body)
    return response === null ? null : clone(response)
  }

  return null
}
